import React from "react";
import { Button as MuiButton } from "@mui/material";
import { ButtonColorEnum, ButtonTypeEnum } from "./ButtonEnums";
import "./Button.scss";

interface IButtonProps {
	label: string;
	color?: ButtonColorEnum;
	onClick?: () => void;
	disabled?: boolean;
	outline?: boolean;
	withShadow?: boolean;
	type?: ButtonTypeEnum;
	id?: string;
}

export const Button: React.FC<IButtonProps> = ({
	label,
	color,
	onClick,
	disabled = false,
	outline = false,
	withShadow = false,
	type = ButtonTypeEnum.BUTTON,
	id,
}) => {
	const classNames = [
		"Button",
		color ? `Button--${color}` : "",
		outline ? "Button--outline" : "",
		withShadow ? "Button--shadow" : "",
	]
		.filter(Boolean)
		.join(" ");

	return (
		<MuiButton
			className={classNames}
			onClick={onClick}
			disabled={disabled}
			type={type}
			id={id}
			disableRipple
			disableElevation
		>
			{label}
		</MuiButton>
	);
};

export default Button;
